// extracted by mini-css-extract-plugin
module.exports = {"not-found":"style_not-found__25JoD"};